// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
            || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

var Scroller = function(rail, train) {
    this.preStop = 60;

    this.rail = rail;
    this.railHeight = rail.outerHeight();
    this.railOffset = rail.offset();

    this.train = train;
    this.trainWidth = train.width();
    this.trainHeight = train.outerHeight();
    this.trainOffset = train.offset();

    this.moving = false;
    this.startMoving = this.trainOffset.top;
    this.stopMoving = (this.railHeight + this.railOffset.top) - this.trainHeight - this.preStop;
    this.callbacks = {};
};

window.Scroller = Scroller;

Scroller.prototype.addCallback = function(callbackName, callback) {
    this.callbacks[callbackName] = callback;
};

Scroller.prototype.run = function(scrollerManager) {
    scrollerManager.add(this);
};

Scroller.prototype.getStart = function() {
    if (this.callbacks.getStart) {
        return this.callbacks.getStart();
    }
    return this.startMoving;
};

Scroller.prototype.getStop = function() {
    if (this.callbacks.getStop) {
        return this.callbacks.getStop();
    }
    return this.stopMoving;
};

Scroller.prototype.checkPosition = function(currentPosition) {
    if (this.callbacks.checkPosition) {
        this.callbacks.checkPosition(currentPosition);
        return;
    }
    startMoving = this.getStart();
    stopMoving = this.getStop();
    if (startMoving > currentPosition) {
        this.doStart();
    } else if (stopMoving < currentPosition) {
        this.doStop();
    } else {
        this.doMove();
    }
};

Scroller.prototype.doStart = function() {
    if (this.callbacks.doStart) {
        return this.callbacks.doStart();
    }
    this.moving = false;
    this.train.width('auto').removeClass('moving-train');
};
Scroller.prototype.doStop = function() {
    if (this.callbacks.doStop) {
        return this.callbacks.doStop();
    }
    this.moving = false;
    this.train.width(this.trainWidth).removeClass('moving-train').addClass('stopped-train');
};
Scroller.prototype.doMove = function() {
    if (this.callbacks.doMove) {
        return this.callbacks.doMove();
    }
    if (!this.moving) {
        this.moving = true;
        this.train.width(this.trainWidth).removeClass('stopped-train').addClass('moving-train');
    }
};

(function($,App) {

    function ScrollerManager() {
        this.raf = window.requestAnimationFrame;
        this.rafInited = false;
        this.lastScrollTop = 0;
        this.scrollMedium = null;
        this.callbacks = [];
        this.callbacksCount = 0;
    }

    ScrollerManager.prototype.loop = function() {
        // do not use this here, because it is the window object
        var scrollTop = self.scrollMedium.scrollTop();
        if (self.lastScrollTop !== scrollTop) {
            self.lastScrollTop = scrollTop;
            for (var i = 0, len = self.callbacksCount; i < len; ++i) {
                self.callbacks[i].checkPosition(scrollTop);
            }
        }
        setTimeout(function () {
            self.raf.call(window, self.loop);
        }, 200);
    };

    ScrollerManager.prototype.init = function() {
        if (!this.rafInited) {
            this.scrollMedium = $(window);
            this.raf.call(window, self.loop);
            this.rafInited = true;
        }
    };

    ScrollerManager.prototype.add = function(callbackScroller) {
        this.init();
        this.callbacks.push(callbackScroller);
        this.callbacksCount++;
    };

    var self = new ScrollerManager();
    App.ScrollerManager = self;

})(jQuery,App);
